module.exports = __webpack_public_path__ + "01337cbf8cb58f21e1411c4c9ae23c87.woff2";